import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#0052B4\" d=\"M0 12c0 .821.083 1.624.24 2.4l11.76.73 11.76-.73a12.05 12.05 0 0 0 0-4.8L12 8.868l-11.76.73C.083 10.375 0 11.177 0 12\"></path><path fill=\"#F0F0F0\" d=\"M23.758 14.4H.238C1.35 19.876 6.193 24 11.998 24s10.648-4.123 11.76-9.6\"></path><path fill=\"#000\" d=\"M.238 9.6h23.52C22.646 4.123 17.804 0 11.998 0S1.35 4.123.238 9.6\"></path><path fill=\"#FFDA44\" d=\"M17.216 9.6H6.781l2.132-1.003-1.135-2.065 2.315.443.293-2.339L12 6.356l1.612-1.72.293 2.339 2.315-.443-1.135 2.065z\"></path><path fill=\"#A2001D\" d=\"M0 12c0 6.628 5.373 12 12 12L2.4 4.8A11.95 11.95 0 0 0 0 12M12 24c6.627 0 12-5.373 12-12 0-2.702-.893-5.195-2.4-7.2z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }